<template>
  <div class="market-service-page">
    <div class="list-main">
      <div class="header">
        <span class="icon"></span>
        <span class="text">{{ $t("marketServices.t00002") }}</span>
      </div>
      <template v-if="!isLoading">
        <p class="empty">{{ $t("marketServices.t00004") }}</p>
      </template>
      <template v-if="isLoading">
        <List
          v-if="myMarketPackageList && myMarketPackageList.length > 0"
          :listData="myMarketPackageList"
        ></List>
        <div
          class="empty market-empty" 
          v-if="!myMarketPackageList || myMarketPackageList.length <= 0"
        >
          <img src="../../assets/images/app-pages/recordEmpty.png" class="icon">
          {{ $t("marketServices.t00005") }}
      </div>
      </template>
    </div>
    <!-- 双击进入活动页面 -->
    <div class="hidden-entry" v-if="false && pageUrl" @click="handleDoubleClick"></div>
    <div class="tips" @click="showActionSheet" v-html="$t('marketServices.t00003')"></div>
    <!-- 客服联系弹窗 -->
    <ActionSheet
      v-model="showSheet"
      :cancel-text="$t('openAccount.t000028')"
      close-on-click-action>
      <div class="actions-box">
        <div class="item van-hairline--bottom" v-for="item in actionsList" :key="item.id" >
          <template v-if="item.type != 'service'">
            <template v-if="isApp">
              <a @click="actionHand(item)">{{item.text}}：{{item.value_display}}</a>
            </template>
            <!--          此处要区分是H5还是APP-->
            <template v-if="!isApp">
              <a :href="`${item.type}:${item.value}`">{{item.text}}：{{item.value_display}}</a>
            </template>
          </template>
          <template v-else>
            <div @click="openService(item)" class="service">
              <p>{{item.text}}：</p>
              <p>{{ $t('m000025') }}</p>
              <van-icon name="arrow" />
            </div>
          </template>
        </div>
      </div>
    </ActionSheet>
  </div>
</template>

<script>
import List from "./components/List.vue";
import { getBrowser } from "@/utils/browser";
import { ActionSheet,Icon } from "vant";

export default {
  components: {
    List,
    ActionSheet,
    [Icon.name]: Icon,
  },
  data() {
    return {
      isApp: getBrowser().isApp,
      myMarketPackageList: [],
      isLoading: false,
      pageUrl: '',
      lastClickTime: 0,
      showSheet: false,
      actionsList: []
    };
  },
  created() {
    // 临时方案
    this.quoteQueryMarketPackage(); 
    // 获取枚举
    // this.getEnumUrl();
  },
  methods: {
    quoteQueryMarketPackage() {
      this.$apis.quoteQueryMarketPackageApi().then(res => {
        if (res.data.error_code == 0) {
          this.myMarketPackageList = res.data.infoS;
        }
      }).finally(_ => {
        this.isLoading = true;
      });
    },
    getEnumUrl() {
      this.$apis.getSystemParam({ code:'d_c_activity_url' }).then(res => {
        const lang = this.$route.query.lang || 'zh-HK'
        if (res.key) {
          const hasParams = res.key.includes('?')
          this.pageUrl = `${res.key}${hasParams ? '&' : '?'}lang=${lang}`
        } else {
          this.pageUrl = ''
        }
      });
    },
    handleDoubleClick() {
      const currentTime = new Date().getTime();
      const timeDiff = currentTime - this.lastClickTime;
      if (timeDiff < 300) {  // 300ms内的两次点击视为双击
        this.pageUrl && (window.location.href = this.pageUrl)
      }
      this.lastClickTime = currentTime;
    },
    onCancel() {
      this.showSheet = false;
    },
    onSelect(item) {
      this.showSheet = false;
    },
    async showActionSheet() {
      if(this.isShowActions) return;
      this.$apis.getEnum({
        key: 'customerServiceUrlApp,customerServicePhone,customerServiceEmail'
      }).then(data => {
        const service = data.find(item => item.key == 'customerServiceUrlApp');
        const phone = data.find(item => item.key == 'customerServicePhone');
        const email = data.find(item => item.key == 'customerServiceEmail');
        this.actionsList = [
          {type: 'service', text: this.$t('m000024'), ...service },
          {type: 'tel', text: this.$t('openAccount.t000029'), ...phone },
          {type: 'mailto', text: this.$t('openAccount.t000030'), ...email }
        ];
        this.showSheet = true;
      })
    },
    getEnum(key){
      return new Promise((resolve) => {
        this.$apis.getEnum({
          key
        }).then(res => {
          resolve(res[0])
        })
      })
    },
    actionHand(item){
      const urls = {
        tel: 'callPhone',
        mailto: 'sendEmail'
      }
      this.$JsBridge.callHandler('jumpPage', {
        type: 2,
        url: urls[item.type],
        data: item.value
      })
    },
    openService(e){
      window.open(e.value, '_blank');
    }
  }
};
</script>

<style lang="less" scoped>
.market-service-page {
  color: #17161c;
  padding: 0 32px;
  padding-bottom: calc(70px + 33.33vh);
  box-sizing: border-box;
  min-height: 100%;
  position: relative;
  .list-main {
    .header {
      height: 88px;
      line-height: 88px;
      font-size: 34px;
      font-weight: 600;
      border-bottom: #f3f3f3 solid 1px;
    }
  }
  .empty {
    margin: 100px 0;
    text-align: center;
    font-size: 28px;
    color: #999;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .icon {
      width: 246px;
      height: 248px;
    }
  }
  .market-empty {
    position: absolute;
    top: 38%;
    left: 50%;
    transform: translate(-50%, -38%);
    margin: 0;
    width: 100%;
  }
  .tips {
    position: absolute;
    left: 0;
    bottom: 30px;
    width: 100%;
    // line-height: 70px;
    font-size: 28px;
    color: #17161C;
    text-align: center;
    z-index: 10;
  }
  .actions-box{
    padding: 0 20px;
    .item{
      display: flex;
      justify-content: center;
      line-height: 100px;
      font-size: 28px;
      a{
        color: #0F0F2F;
        font-weight: 400;
      }
      .service{
        line-height: 40px;
        text-align: center;
        padding: 10px 0;
        position: relative;
        width: 100%;
        p{
          font-size: 24px;
        }
        .van-icon{
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          font-size: 40px;
        }
      }
    }
  }
}
.black-theme {
  .empty{
    color: #9D9D9F;
  }
  .market-service-page {
    color: #fff;
    .list-main {
      .header {
        border-color: #323442;
      }
    }
  }
  .tips {
    color: white;
  }
  .actions-box{
    .item{
      a{
        color: #fff;
      }
    }
  }
}
.hidden-entry {
  position: fixed;
  bottom: 120px;
  left: 0;
  width: 100%;
  height: 33.33vh;
  z-index: 2000;
  pointer-events: auto;
  background: transparent;
}
</style>
